export const ADDRESS_SUGGESTIONS_URL =
  "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?";

export const ADDRESS_CANDIDATES_URL =
  "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?";

export const ESRI_API_KEY = process.env.REACT_APP_ESRI_GEOLOCATOR_API_KEY;
export const POLYTODO_BASE_URL = process.env.REACT_APP_POLYTODO_BASE_URL;
export const FORM_STATE_MODE = "mode";
export const FORM_STATE_LOADING = "loading";
export const FORM_STATE_SUBMITTED = "submitted";
export const FORM_STATE_ERROR = "error";

export const CONTACT_US_URL = "https://www.gpsit.co.nz/contact-us-gpsit";

export const ORCHARD_LABEL = "Orchard";
export const FARM_LABEL = "Farm";
export const OTHER_LABEL = "Other";


export const PROPERTY_CATEGORIES = [
  { value: "Orchard", label: ORCHARD_LABEL },
  { value: "Farm", label: FARM_LABEL },
  { value: "Other", label: OTHER_LABEL }
];

export const ORCHARD_TYPES = [
  { value: "Kiwifruit Orchard", label: "Kiwifruit Orchard" },
  { value: "Apple Orchard", label: "Apple Orchard" },
  { value: "Avo Orchard", label: "Avocado Orchard" },
  { value: "Blueberry Orchard", label: "Blueberry Orchard" },
  { value: "Citrus Orchard", label: "Citrus Orchard" },
  { value: "Mixed Orchard", label: "Mixed Orchard" },
  { value: "Stonefruit Orchard", label: "Stonefruit Orchard" },
];

export const ORCHARD_JOB_TYPES = [
  {
    value: "Drone Only",
    label: "Only imagery capture (no survey required)"
  },
  { value: "Orchard Survey", label: "An orchard survey map" },
  {
    value: "Tender Survey",
    label: "An orchard survey map specifically for a tender process"
  }
];

export const FARM_TYPES = [
  { value: "Cropping Farm", label: "Cropping Farm" },
  { value: "Dairy Farm", label: "Dairy Farm" },
  { value: "Deer Farm", label: "Deer Farm" },
  { value: "Drystock", label: "Dry Stock" },
  { value: "Goat Farm", label: "Goat Farm" },
  {
    value: "Sheep and Beef Farm",
    label: "Sheep and Beef Farm"
  },
  { value: "Mixed Farm", label: "Mixed Farm" },
  { value: "Other", label: "Other" }
];

export const FARM_JOB_TYPES = [
  {
    value: "Draft Only",
    label: "A map with the latest publicly available imagery"
  },
  {
    value: "Drone and Draft",
    label: "A map with premium drone imagery"
  }
];
